export const flightBookingRoles = ['general_manager', 'sales_manager', 'sales_supervisor', 'reservation_manager', 'reservation_supervisor']
